import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { IMdResourceDetail, IMdResourceFields, IMdResourceSearch } from "./ResourceTypes";

class ResourceService {

    /**
     * 新增资源
     * @param params 
     * @returns 
     */
    async insert(params: IMdResourceFields) {
        const apiUrl = "/auth/resource/insert";
        return await httpRequest.post<IMdResourceDetail>(apiUrl, params);
    }

    /**
     * 修改资源
     * @param params 
     * @returns 
     */
    async update(params: IMdResourceFields) {
        const apiUrl = "/auth/resource/update";
        return await httpRequest.post<boolean>(apiUrl, params);
    }

    /**
     * 删除资源
     * @param code 
     * @returns 
     */
    async remove(code: string) {
        const apiUrl = `/auth/resource/remove/${code}`;
        return await httpRequest.post<boolean>(apiUrl);
    }

    /**
     * 查询资源
     * @param params 
     * @returns 
     */
    async find(params: IMdResourceFields) {
        const apiUrl = "/auth/resource/find";
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl, params);
    }

    /**
     * 按照appCode查询资源
     * @param code
     */
    async findByApp(code: string) {
        const apiUrl = `/auth/resource/findByApp/${code}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照menuCode查询资源
     * @param code
     * @returns 
     */
    async findByMenu(code: string) {
        const apiUrl = `/auth/resource/findByMenu/${code}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照roleCode查询资源
     * @param code
     * @returns 
     */
    async findByRole(code: string) {
        const apiUrl = `/auth/resource/findByRole/${code}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照userCode查询资源
     * @param code
     * @returns 
     */
    async findByUser(code: string) {
        const apiUrl = `/auth/resource/findByUser/${code}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照user和app查询资源
     * @param code
     * @returns 
     */
    async findByUserAndApp(userCode: string, appCode: string) {
        const apiUrl = `/auth/resource/findByUserApp/${userCode}/${appCode}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照user和menu查询资源
     * @param code
     * @returns 
     */
    async findByUserAndMenu(userCode: string, menuCode: string) {
        const apiUrl = `/auth/resource/findByUserMenu/${userCode}/${menuCode}`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl);
    }

    /**
     * 按照app和menu查询资源
     * @param code
     * @returns 
     */
    async findByAppAndMenu(appCode: string, menuCode: string) {
        const apiUrl = `/auth/resource/findByAppMenu`;
        return await httpRequest.post<IMdResourceDetail[]>(apiUrl,{appCode,menuCode});
    }

    /**
     * 查询一条资源详情
     * @param code
     * @returns 
     */
    async findOne(code: string) {
        const apiUrl = `/auth/resource/findOne/${code}`;
        return await httpRequest.post<IMdResourceDetail>(apiUrl);
    }

    /**
     * 分页查询资源列表
     * @param params 
     * @returns 
     */
    async page(params: IMdResourceSearch) {
        const apiUrl = "/auth/resource/findPage";
        return await httpRequest.post<IPage<IMdResourceDetail>>(apiUrl, params)
    }

}
export const resourceService = new ResourceService();
